import React from "react";
import InterestForm from "@/components/InterestForm";

/**
 * Minimal, form-only registration page for people who paid off-platform (Zelle, cash, etc.).
 * No navbar, no hero, no urgency bar — just the form. They've already paid, they just need
 * to give us their info.
 */
export default function RegisterPaid() {
  return (
    <div className="min-h-screen bg-[#FAFAF7] py-10 md:py-16" data-testid="register-paid-page">
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <div className="text-center mb-8">
          <img
            src="/ssu-logo.png"
            alt="SSU Workshops"
            className="h-14 md:h-16 mx-auto mb-6"
          />
          <div className="inline-flex items-center gap-2 px-3 py-1 bg-[#25D366]/15 text-[#25D366] rounded-full mb-4 text-[10px] md:text-xs font-black uppercase tracking-[0.25em]">
            ✓ Ticket paid · Just need your info
          </div>
          <h1 className="font-display text-3xl md:text-4xl text-[#0A1128] leading-tight mb-2">
            Fill out your attendee info
          </h1>
          <p className="text-sm md:text-base text-[#6B7280] max-w-lg mx-auto leading-relaxed">
            Takes about 2 minutes. When you hit submit we&apos;ll drop you straight into the SSU Workshops WhatsApp group.
          </p>
        </div>

        <InterestForm mode="paid" />
      </div>
    </div>
  );
}
